<div class="product-item">
  <svg-icon
    [src]="icon"
  ></svg-icon>
  <div class="product-title">{{ 'header.products.' + productsKey + '.title' | translate }}</div>
  <div class="product-description">{{ 'header.products.' + productsKey + '.description' | translate }}</div>
  <a [routerLink]="route" [fragment]="fragment" class="product-action-link">
    <liberro-button widthType="width-100" (click)="onActionBtnClick()">
      <span>{{ 'header.products.' + productsKey + '.moreBtn' | translate }}</span>
      <svg-icon class="link-arrow" src="assets/icons/header-link-arrow.svg"></svg-icon>
    </liberro-button>
  </a>
</div>